import React from 'react';
import useSwitchUserPage from "v4/pages/front/SwitchUser/hooks/useSwitchUserPage";
import { useTranslation } from "react-i18next";

export default function SwitchUserPage() {
    const { t } = useTranslation();
    const { isLoading } = useSwitchUserPage();

    return (
        <div className="switch-user-page">
            {isLoading && <p>{t('loading')}...</p>}
        </div>
    );
}
